export default __webpack_public_path__ + "static/media/Q15_3_resized.1efcaf0e.jpg";